import clsx from "clsx";

import { TransactionStatusType } from "@interfaces/index";
import { LockSvg, LockOpenSvg } from "@components/index";

export const TransactionStatus = ({
  status,
}: {
  status: {
    label: string;
    value: TransactionStatusType;
  };
}) => (
  <div
    className={clsx(
      "flex w-fit items-center gap-x-1 rounded-2xl px-2.5 py-1 text-button *:size-[18px] *:shrink-0",
      status.value === "open" && "bg-primary-108 text-primary-300",
      status.value === "reopened" && "bg-red-8 text-red-100",
      ["submitted", "completed"].includes(status.value) &&
        "bg-green-8 text-green-100",
      status.value === "added_by_accountant" &&
        "bg-magenta-208 text-magenta-200",
      status.value === "updated_by_accountant" &&
        "bg-magenta-308 text-magenta-300",
    )}
  >
    {["open", "reopened"].includes(status.value) && <LockOpenSvg />}
    {["submitted", "completed"].includes(status.value) && <LockSvg />}
    {["added_by_accountant", "updated_by_accountant"].includes(
      status.value,
    ) && (
      <div
        className={clsx(
          "h-3 w-3 shrink-0 rounded-full border-2",
          status.value === "added_by_accountant" && "border-magenta-200",
          status.value === "updated_by_accountant" && "border-magenta-300",
        )}
      />
    )}
    {status.label}
  </div>
);
